export default "__VITE_ASSET__BoqOw7mT__"